export const packConfigForCheckingAvailability = [
    "HS",
    "PF",
    "PFP",
    "PFTT",
    "PFTTF",
    "PFPTTF",
    "PFCS",
    "PFPCS",
    "CVPD",
    "CVDP",
    "CVPC",
    "CVAL",
    "PMA"
]
